<section>
  <app-form-header></app-form-header>
  @if (form && hasRecipients) {
    <form class="send-tenant-email-form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (showRecipients && recipients.length) {
        <section class="astral-section-surface astral-stack-s">
          <h4 class="send-tenant-email-form__section-title">{{ 'MULTI_TENANT_FORM.RECIPIENT_HEADER' | translate }}</h4>
          <div class="send-tenant-email-form__recipient-list">
            @for (recipient of recipients; track recipient; let i = $index) {
              <astral-chip
                class="send-tenant-email-form__recipient"
                [label]="recipient.recipientName"
                [removable]="recipients.length > 1"
                removeAriaLabelKey="COMMON.REMOVE"
                (remove)="removeRecipient(recipient, i)"
              ></astral-chip>
            }
          </div>
        </section>
      }
      <section class="astral-section-surface astral-form-stack">
        <astral-input [control]="form.controls['subject']"></astral-input>
        <astral-textarea [control]="form.controls['body']" [rows]="20"></astral-textarea>
        <app-file-upload [forms]="form.controls['attachments']" buttonVariant="primary"></app-file-upload>
      </section>
      <div class="astral-form-actions">
        <astral-button type="button" variant="primary" labelKey="SEND_BTN" [disabled]="isSendDisabled" (click)="send()"></astral-button>
        <astral-button type="button" variant="secondary" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      </div>
    </form>
  }
</section>
